export default __webpack_public_path__ + "static/media/usuario.c1111bd6.png";